import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import axios from 'axios';
import { resolveImageUrl } from '@/utils/image';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'Gallery', path: '/gallery' },
  { name: 'Packages', path: '/packages' },
  { name: 'Contact', path: '/contact' },
];

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [logoUrl, setLogoUrl] = useState('');

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    axios.get(`${API}/settings`).then(res => setLogoUrl(res.data.logo_url || '')).catch(() => {});
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'glass-nav py-3' : 'bg-transparent py-5'}`}>
      <div className="px-6 md:px-12 lg:px-24 flex justify-between items-center">
        <Link to="/" data-testid="logo-link" className="block">
          {logoUrl ? (
            <img src={resolveImageUrl(logoUrl)} alt="Jay Captures" className={`w-auto object-contain transition-all duration-300 ${scrolled ? 'h-10 md:h-12' : 'h-16 md:h-20'}`} data-testid="nav-logo-img" />
          ) : (
            <span className="text-2xl font-medium" style={{ fontFamily: 'Playfair Display, serif' }}>Jay Captures</span>
          )}
        </Link>
        <div className="hidden md:flex gap-10 items-center">
          {navLinks.map((link) => (
            <Link key={link.path} to={link.path} className="text-sm uppercase tracking-widest hover:text-gray-400 transition-colors" data-testid={`nav-${link.name.toLowerCase()}`}>{link.name}</Link>
          ))}
          <Link to="/contact" className="border border-white/30 text-white hover:bg-white hover:text-black px-5 py-2 text-xs uppercase tracking-widest transition-all duration-300" data-testid="nav-enquire-btn">Enquire</Link>
        </div>
        <button className="md:hidden text-white" onClick={() => setIsOpen(!isOpen)} data-testid="mobile-menu-toggle">
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="md:hidden glass-nav" data-testid="mobile-menu">
            <div className="px-6 py-6 flex flex-col gap-6">
              {navLinks.map((link) => (
                <Link key={link.path} to={link.path} className="text-sm uppercase tracking-widest hover:text-gray-400 transition-colors" onClick={() => setIsOpen(false)} data-testid={`mobile-nav-${link.name.toLowerCase()}`}>{link.name}</Link>
              ))}
              <Link to="/contact" className="inline-block text-center border border-white/30 text-white hover:bg-white hover:text-black px-5 py-3 text-sm uppercase tracking-widest transition-all duration-300" onClick={() => setIsOpen(false)} data-testid="mobile-enquire-btn">Enquire</Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navigation;
